import {Button, Switch} from '@wandb/weave/components';
import {Tag} from '@wandb/weave/components/Tag';
import React, {useEffect} from 'react';

import {useIssuesContext} from '../../../state/issues/IssuesContext';
import {useWorkspaceDrawerContext} from '../WorkspaceDrawerContextProvider';
import {EmptyRunIssuesDrawer} from './EmptyRunIssuesDrawer';
import {GrafanaIcon} from './GrafanaIcon';
import {IssuesWelcomeBanner} from './IssuesWelcomeBanner';
import {RunIssuesList} from './RunIssue';
export const RunIssuesDrawer = () => {
  const {
    activeRun,
    activeIssues = [],
    annotationActive,
    currentIssue,
    toggleIssues,
  } = useIssuesContext();

  const {closeWorkspaceDrawer, contentType} = useWorkspaceDrawerContext();

  // scroll to the current selected issue when the drawer opens. Hovering an issue will cause it to become the current issue, and then clicking it will fire the drawer open event (changing the content type on the drawer). Thus, when the drawer opens we will have an active issue to scroll to if one is being interacted with.
  useEffect(() => {
    if (contentType === 'run-issues') {
      const issueToScrollTo = document.getElementById(currentIssue ?? '');
      if (issueToScrollTo) {
        issueToScrollTo.scrollIntoView({behavior: 'auto'});
      }
    }
    // exhaustive hooks is disabled because we only want this to fire when the drawer opens, not when the issue changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contentType]);

  const linkURL = `https://cks-grafana.coreweave.com/d/slurm-job-metrics/slurm-job-metrics?orgId=1&from=1746054600000&to=1746162000000&var-datasource=default&var-logs_datasource=P32A5321E182D1325&var-cluster_org=cw1337&var-cluster=ml-dev-usw1a&var-namespace=tenant-slurm&var-slurm_cluster=slurm&var-job_name=All&var-ib_fabric_nodes_filter=All&var-ib_fabric=All&var-job_id=476&var-alert_state=firing&var-ts_last_running=1746514500/node-details?orgId=1&var-node=g1c7168&from=1746054600000&to=1746162000000`;

  return (
    <div className=" flex h-full w-full flex-col">
      <header
        className="flex-grow-0 border-b-[1px] border-moon-250 px-20 py-12"
        data-test="run-issues-drawer-header">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-8">
            <h1 className="text-lg font-semibold">Issues</h1>
            <Tag label={activeIssues.length.toString()} color="moon" />
          </div>
          <div className="flex items-center gap-8">
            <label htmlFor="annotate-issues-switch">Annotate issues</label>
            <Switch.Root
              checked={annotationActive}
              id="annotate-issues-switch"
              onCheckedChange={toggleIssues}
              size="medium">
              <Switch.Thumb checked={annotationActive} size="medium" />
            </Switch.Root>
            <Button
              startIcon="close"
              variant="ghost"
              onClick={() => closeWorkspaceDrawer(false)}
            />
          </div>
        </div>
      </header>
      <div className="flex-grow overflow-y-auto">
        <div className="m-24">
          <IssuesWelcomeBanner />
          <div className="mt-12 text-[15px] font-semibold">Run</div>
          <div className="flex items-center gap-4">
            <div>{activeRun?.displayName}</div>
            <div className="h-4 w-4 rounded-full" />
            <Button
              variant="ghost"
              onClick={() => {
                // eslint-disable-next-line
                window.open(linkURL, '_blank', 'noopener noreferrer');
              }}>
              <span className="flex items-center gap-4">
                <GrafanaIcon height={16} width={16} />
                Grafana
              </span>
            </Button>
          </div>
        </div>

        {activeIssues.length < 1 ? (
          <EmptyRunIssuesDrawer />
        ) : (
          <div className="m-24 mt-16" data-test="run-issues-drawer-issues">
            <RunIssuesList currentIssue={currentIssue} issues={activeIssues} />
          </div>
        )}
      </div>
    </div>
  );
};
